export class Cart {
    id: number;
    user: number;
    ref: string;
    ean: string;
    uds: number;
    provider: number;
    date: any;
}
